import loadable from '@loadable/component';

export const OrgDashboardListIntegrationsPageLoadable = loadable(
  () => import('./OrgDashboardListIntegrationsPage'),
  { resolveComponent: (module) => module.OrgDashboardListIntegrationsPage },
);
